import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatatableAction } from '../../types/datatable-action';

@Component({
  selector: 'table-row-actions',
  templateUrl: './row-actions.component.html',
  styleUrls: ['./row-actions.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatMenuModule, CommonModule],
})
export class RowActionsComponent {
  row = input<any>();
  actions = input<DatatableAction<any>[]>();
  combineActionsThreshold = input<number>();
  isCompactMode = input(false);

  doCombine = computed(() => this.actions()?.length > (this.combineActionsThreshold() ?? 1));

  hideAllActions = computed(() => this.actions().every((a) => !this.doShow(a)));

  doShow(action: DatatableAction<any>) {
    return !action.doHide?.(this.row());
  }

  getHoverText(action: DatatableAction<any>) {
    if (action.doDisable?.(this.row()) && action.disabledHoverText) {
      return typeof action.disabledHoverText === 'function'
        ? action.disabledHoverText(this.row())
        : action.disabledHoverText;
    }
    if (typeof action.hoverText === 'function') {
      return action.hoverText(this.row());
    }
    return action.hoverText;
  }
}
